import React from "react";
import { FiMenu, FiX } from "react-icons/fi";
import ReactCountryFlag from "react-country-flag";

const Header = ({
  t,
  language,
  setLanguage,
  isMenuOpen,
  setIsMenuOpen,
  isLoginOpen,
  setIsLoginOpen,
  isLangOpen,
  setIsLangOpen,
  scrollToSection,
  handleLoginSelect,
  isAuthenticated = false,
  handleDashboard,
  loginMenuRef,
  loginMenuMobileRef,
  langMenuRef,
  hideNav = false,
}) => (
  <header className="home-header">
    <div className="home-container header-inner">
      <button
        className="brand"
        type="button"
        onClick={() => {
          scrollToSection("hero");
          setIsMenuOpen(false);
        }}
        aria-label="Cargotronics"
      >
        <img
          className="brand-logo desktop-logo"
          src={`${process.env.PUBLIC_URL}/Cargotronics.png`}
          alt="Cargotronics"
        />
        <img
          className="brand-logo mobile-logo"
          src={`${process.env.PUBLIC_URL}/Cargotronics.png`}
          alt="Cargotronics"
        />
      </button>
      {!hideNav && (
      <nav className={`home-nav ${isMenuOpen ? "open" : ""}`}>
        <a
          href="#producto"
          onClick={(event) => {
            event.preventDefault();
            scrollToSection("producto");
            setIsMenuOpen(false);
          }}
        >
          {t.nav.producto}
        </a>
        <a
          href="#integraciones"
          onClick={(event) => {
            event.preventDefault();
            scrollToSection("integraciones");
            setIsMenuOpen(false);
          }}
        >
          {t.nav.integraciones}
        </a>
        <a
          href="#mundo-gps"
          onClick={(event) => {
            event.preventDefault();
            scrollToSection("mundo-gps");
            setIsMenuOpen(false);
          }}
        >
          {t.nav.mundo}
        </a>
        <a
          href="#casos"
          onClick={(event) => {
            event.preventDefault();
            scrollToSection("casos");
            setIsMenuOpen(false);
          }}
        >
          {t.nav.casos}
        </a>
        {/* <a
          href="#precios"
          onClick={(event) => {
            event.preventDefault();
            scrollToSection("precios");
            setIsMenuOpen(false);
          }}
        >
          {t.nav.precios}
        </a> */}
        <a
          href="#recursos"
          onClick={(event) => {
            event.preventDefault();
            scrollToSection("recursos");
            setIsMenuOpen(false);
          }}
        >
          {t.nav.recursos}
        </a>
        <a
          href="#contacto"
          onClick={(event) => {
            event.preventDefault();
            scrollToSection("contacto");
            setIsMenuOpen(false);
          }}
        >
          {t.nav.contacto}
        </a>
        <div className="mobile-cta">
          <div className="login-dropdown" ref={loginMenuMobileRef}>
            <button
              className="btn btn-ghost dropdown-toggle"
              type="button"
              onClick={isAuthenticated ? handleDashboard : () => setIsLoginOpen((prev) => !prev)}
              aria-expanded={isLoginOpen}
            >
              {isAuthenticated ? "Dashboard" : t.buttons.ingresar}
            </button>
            {!isAuthenticated && isLoginOpen && (
              <div className="dropdown-menu">
                <button type="button" onClick={() => handleLoginSelect("cargotronics")}>
                  Cargotronics
                </button>
                <button type="button" onClick={() => handleLoginSelect("logiseguridad")}>
                  Logiseguridad
                </button>
              </div>
            )}
          </div>
          <div className="mobile-lang">
            <span>{language === "es" ? "Idioma" : "Language"}</span>
            <div className="mobile-lang-actions">
              <label className="lang-check">
                <ReactCountryFlag countryCode="ES" svg className="lang-flag" />
                <span>Español</span>
                <input
                  type="checkbox"
                  checked={language === "es"}
                  onChange={() => setLanguage("es")}
                />
              </label>
              <label className="lang-check">
                <ReactCountryFlag countryCode="US" svg className="lang-flag" />
                <span>English</span>
                <input
                  type="checkbox"
                  checked={language === "en"}
                  onChange={() => setLanguage("en")}
                />
              </label>
            </div>
          </div>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              scrollToSection("contacto");
              setIsMenuOpen(false);
            }}
          >
            {t.buttons.solicitarDemo}
          </button>
        </div>
      </nav>
      )}
      <div className="header-cta" style={hideNav ? { marginLeft: "auto" } : undefined}>
        <div className="login-dropdown" ref={loginMenuRef}>
          <button
            className="btn btn-ghost dropdown-toggle"
            type="button"
            onClick={isAuthenticated ? handleDashboard : () => setIsLoginOpen((prev) => !prev)}
            aria-expanded={isLoginOpen}
          >
            {isAuthenticated ? "Dashboard" : t.buttons.ingresar}
          </button>
          {!isAuthenticated && isLoginOpen && (
            <div className="dropdown-menu">
              <button type="button" onClick={() => handleLoginSelect("cargotronics")}>
                Cargotronics
              </button>
              <button type="button" onClick={() => handleLoginSelect("logiseguridad")}>
                Logiseguridad
              </button>
            </div>
          )}
        </div>
        {!hideNav && (
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              scrollToSection("contacto");
              setIsMenuOpen(false);
            }}
          >
            {t.buttons.solicitarDemo}
          </button>
        )}
      </div>
      <div className="lang-switch" ref={langMenuRef}>
        <button
          className="lang-toggle"
          type="button"
          onClick={() => setIsLangOpen((prev) => !prev)}
          aria-expanded={isLangOpen}
        >
          <ReactCountryFlag
            countryCode={language === "es" ? "ES" : "US"}
            svg
            className="lang-flag"
          />
        </button>
        {isLangOpen && (
          <div className="lang-menu">
            <label className="lang-check">
              <ReactCountryFlag countryCode="ES" svg className="lang-flag" />
              <span>Español</span>
              <input
                type="checkbox"
                checked={language === "es"}
                onChange={() => {
                  setLanguage("es");
                  setIsLangOpen(false);
                }}
              />
            </label>
            <label className="lang-check">
              <ReactCountryFlag countryCode="US" svg className="lang-flag" />
              <span>English</span>
              <input
                type="checkbox"
                checked={language === "en"}
                onChange={() => {
                  setLanguage("en");
                  setIsLangOpen(false);
                }}
              />
            </label>
          </div>
        )}
      </div>
      {!hideNav && (
        <button
          className="menu-toggle"
          type="button"
          aria-label={
            isMenuOpen
              ? language === "es"
                ? "Cerrar menú"
                : "Close menu"
              : language === "es"
                ? "Abrir menú"
                : "Open menu"
          }
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          {isMenuOpen ? <FiX /> : <FiMenu />}
        </button>
      )}
    </div>
    {!hideNav && (
      <div
        className={`menu-backdrop ${isMenuOpen ? "show" : ""}`}
        onClick={() => setIsMenuOpen(false)}
        role="button"
        tabIndex={-1}
        aria-hidden="true"
      />
    )}
  </header>
);

export default Header;
